<div class="flex column">
	<slot />
</div>

<style>
	div { 
		gap: 15px;
	}
</style>